import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class DemandStatsModel extends ApiModel {
  static get path() {
    return '/backend/demands/stats';
  }

  @computed
  get exemptionMountingValidated() {
    return this.get('byTypeAndStatus.exemption_mounting.validated.total', 0);
  }

  @computed
  get exemptionMountingInProgress() {
    return this.get('byTypeAndStatus.exemption_mounting.in_progress.total', 0);
  }

  @computed
  get exemptionMountingRefused() {
    return this.get('byTypeAndStatus.exemption_mounting.refused.total', 0);
  }

  @computed
  get exemptionDismantlingValidated() {
    return this.get('byTypeAndStatus.exemption_dismantling.validated.total', 0);
  }

  @computed
  get exemptionDismantlingInProgress() {
    return this.get('byTypeAndStatus.exemption_dismantling.in_progress.total', 0);
  }

  @computed
  get exemptionDismantlingRefused() {
    return this.get('byTypeAndStatus.exemption_dismantling.refused.total', 0);
  }

  @computed
  get exemptionDeliveryValidated() {
    return this.get('byTypeAndStatus.exemption_delivery.validated.total', 0);
  }

  @computed
  get exemptionDeliveryInProgress() {
    return this.get('byTypeAndStatus.exemption_delivery.in_progress.total', 0);
  }

  @computed
  get exemptionDeliveryRefused() {
    return this.get('byTypeAndStatus.exemption_delivery.refused.total', 0);
  }

  @computed
  get logisticMaterialValidated() {
    return this.get('byTypeAndStatus.logistic_material.validated.total', 0);
  }

  @computed
  get logisticMaterialInProgress() {
    return this.get('byTypeAndStatus.logistic_material.in_progress.total', 0);
  }

  @computed
  get logisticMaterialRefused() {
    return this.get('byTypeAndStatus.logistic_material.refused.total', 0);
  }

  @computed
  get logisticVehicleValidated() {
    return this.get('byTypeAndStatus.logistic_vehicle.validated.total', 0);
  }

  @computed
  get logisticVehicleInProgress() {
    return this.get('byTypeAndStatus.logistic_vehicle.in_progress.total', 0);
  }

  @computed
  get logisticVehicleRefused() {
    return this.get('byTypeAndStatus.logistic_vehicle.refused.total', 0);
  }

  @computed
  get exemptionValidated() {
    return this.exemptionMountingValidated + this.exemptionDismantlingValidated + this.exemptionDeliveryValidated;
  }

  @computed
  get exemptionInProgress() {
    return this.exemptionMountingInProgress + this.exemptionDismantlingInProgress + this.exemptionDeliveryInProgress;
  }

  @computed
  get exemptionRefused() {
    return this.exemptionMountingRefused + this.exemptionDismantlingRefused + this.exemptionDeliveryRefused;
  }

  @computed
  get logisticValidated() {
    return this.logisticMaterialValidated + this.logisticVehicleValidated;
  }

  @computed
  get logisticInProgress() {
    return this.logisticMaterialInProgress + this.logisticVehicleInProgress;
  }

  @computed
  get logisticRefused() {
    return this.logisticMaterialRefused + this.logisticVehicleRefused;
  }

  @computed
  get total() {
    return this.get('totals.count', 0)
  }

  @computed
  get totalUnSeen() {
    return this.get('totals.unSeen', 0);
  }

  @computed
  get totalTreated() {
    return this.get('totals.treated', 0);
  }

  @computed
  get totalUnTreated() {
    return this.total - this.totalTreated;
  }
}
